// Wires up the cookie banner and settings dialog rendered by
// cookie_consent/_banner. Loaded on every page that renders that partial,
// independent of the page's pack.
import { choiceForAction, saveConsent, ConsentAction } from '../utils/consent/cookieConsent';

const banner = document.getElementById('hk-consent-banner');
const dialog = document.getElementById('hk-consent-dialog') as HTMLDialogElement | null;

function toggle(name: string): boolean {
  const input = dialog?.querySelector<HTMLInputElement>(`input[name="${name}"]`);
  return Boolean(input?.checked);
}

function openSettings(): void {
  if (!dialog) return;
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
}

function closeAll(): void {
  if (banner) banner.hidden = true;
  if (dialog?.open) dialog.close();
}

document.addEventListener('click', (event) => {
  const target = event.target as HTMLElement | null;

  // Footer "Cookie settings" / "Do Not Sell or Share" link, on any page.
  if (target?.closest('[data-cookie-settings]')) {
    event.preventDefault();
    openSettings();
    return;
  }

  const button = target?.closest<HTMLElement>('[data-consent-action]');
  if (!button) return;
  event.preventDefault();

  const action = button.dataset.consentAction;
  if (action === 'manage') {
    openSettings();
    return;
  }

  const choice = choiceForAction(action as ConsentAction, {
    analytics: toggle('analytics'),
    marketing: toggle('marketing'),
  });
  if (!saveConsent(choice)) closeAll();
});

(window as any).openCookieSettings = openSettings;
